import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getMobilePref, useIsMobileViewport } from './useViewport';

/**
 * Sits inside the Router. When a user with a mobile-sized viewport lands on
 * a desktop-only path (anything outside `/m/*`, `/login`, etc.), redirect to
 * the mobile experience. Respects a per-device override via getMobilePref().
 */
const MobileRedirectGuard: React.FC = () => {
  const isMobile = useIsMobileViewport();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobile) return;
    const pref = getMobilePref();
    if (pref === 'desktop') return;

    const p = location.pathname;
    // Skip auth pages, the mobile app itself, and printable export previews.
    if (
      p.startsWith('/m') ||
      p.startsWith('/login') ||
      p.startsWith('/reset-password') ||
      p.startsWith('/agent/approve') ||
      p.startsWith('/agent/verify-alias') ||
      p.startsWith('/register-admin') ||
      p.startsWith('/pdf-export-preview') ||
      p.startsWith('/proposal-editor')
    ) return;

    navigate('/m', { replace: true });
  }, [isMobile, location.pathname, navigate]);

  return null;
};

export default MobileRedirectGuard;
